import { GuidedSellingStepT, GuidedSellingTag } from "@swo/storefront";
import { pipe } from "fp-ts/pipeable";
import { array, option } from "fp-ts";

export function getAllTags(choicesIds: Array<string>, step: GuidedSellingStepT): Array<GuidedSellingTag> {
  switch (step.type) {
    case "final":
      return [];
    case "not-final": {
      return pipe(
        choicesIds,
        array.head,
        option.fold(
          () => [],
          choiceId => {
            const restChoicesIds = pipe(
              choicesIds,
              array.tail,
              option.getOrElseW(() => []),
            );

            const choice = [...step.choices].find(v => v.id === choiceId);
            return choice ? [...choice.tags, ...getAllTags(restChoicesIds, choice.nextStep)] : [];
          },
        ),
      );
    }
    default: {
      const _: never = step;

      return _;
    }
  }
}
